import styled from 'styled-components'
import { Select } from 'antd'
import { greys } from 'assets/themes/theme-default'

const AntSelectStyled = styled(Select)`
  &&& {
    .ant-select-arrow {
      color: ${greys.light4};
      width: 50px;
      height: 100%;
      background-color: ${props => props.theme.colors.color1.bg};
      margin: -22px -12px;
      padding: 15px 0;
    }

    .ant-select-dropdown-menu-item:hover:not(.ant-select-dropdown-menu-item-disabled),
    .ant-select-dropdown-menu-item-active:not(.ant-select-dropdown-menu-item-disabled) {
      background-color: ${props => props.theme.colors.color1.bg};
      color: ${greys.light4};
    }

    .ant-select-dropdown-menu-item-selected,
    .ant-select-dropdown-menu-item-selected:hover {
      background-color: ${props => props.theme.colors.color1.bg};
      color: ${greys.light4};
    }
  }
`

export default AntSelectStyled
